<div class="pr-funnel-children-data">
  <div class="pr-funnel-children-data__info">
    <div class="pr-funnel-children-data__index">
      <span>{{ index + 1 }}</span>
    </div>
    <button
      type="button"
      class="pr-funnel-children-data__delete"
      (click)="delete()"
    >
      <img src="assets/svg/ressources/bin.svg" />
    </button>
  </div>

  <div class="pr-funnel-children-data__input">
    <div class="pr-funnel-children-data__line1">
      <div class="pr-funnel-children-data__input-container">
        <div class="pr-funnel-children-data__label-container">
          <span>{{ type === 'child' ? 'Prénom' : 'Nom' }}</span>
        </div>
        @if (type === 'child') {
          <pr-input
            [derrors]="derrors"
            [highlightOnValue]="true"
            [highlightOnFocus]="true"
          >
            <input
              formControlName="firstName"
              type="text"
              placeholder="Ex. : Clara"
            />
          </pr-input>
        }
        @if (type === 'corporate') {
          <pr-input
            [derrors]="derrors"
            [highlightOnValue]="true"
            [highlightOnFocus]="true"
          >
            <input
              formControlName="name"
              type="text"
              placeholder="Ex. : NP Consulting"
            />
          </pr-input>
        }
      </div>
      <div class="pr-funnel-children-data__input-container">
        <div class="pr-funnel-children-data__label-container">
          <span>{{ type === 'child' ? 'Issu(e)' : 'Type' }}</span>
        </div>
        @if (type === 'child') {
          <pr-select-form
            [options]="childFiliations"
            formControlName="origin"
            [derrors]="derrors"
            placeholder="Choisissez"
          >
          </pr-select-form>
        }
        @if (type === 'corporate') {
          <pr-select-form
            [options]="corporateTypes"
            formControlName="type"
            [derrors]="derrors"
            placeholder="Choisissez"
          >
          </pr-select-form>
        }
      </div>
    </div>

    <!-- Line 2 for children -->
    @if (type === 'child') {
      <div class="pr-funnel-children-data__line2">
        <div class="pr-funnel-children-data__input-container">
          <div class="pr-funnel-children-data__label-container">
            <span>Né(e) le</span>
          </div>
          <pr-input-date
            formControlName="birthDate"
            [derrors]="derrors"
            [highlightOnValue]="true"
            [highlightOnFocus]="true"
          >
          </pr-input-date>
        </div>
        <div class="pr-funnel-children-data__checkboxs">
          <pr-input-checkbox
            formControlName="dependant"
            label="À charge"
          ></pr-input-checkbox>
          <pr-input-checkbox
            formControlName="handicap"
            label="Handicapé"
          ></pr-input-checkbox>
        </div>
      </div>
    }

    <!-- Line 2 for corporate -->
    @if (type === 'corporate') {
      <div class="pr-funnel-children-data__line2">
        <div class="pr-funnel-children-data__input-container">
          <div class="pr-funnel-children-data__label-container">
            <span>Gérant</span>
          </div>
          <pr-input
            [derrors]="derrors"
            [highlightOnValue]="true"
            [highlightOnFocus]="true"
          >
            <input
              formControlName="manager"
              type="text"
              placeholder="Ex. : Nicolas Peycru"
            />
          </pr-input>
        </div>
      </div>
    }
  </div>
</div>
